export function locationObj(objID, array, start, end) {
  start = start || 0;
  end = end || array.length;
  var pivot = parseInt(start + (end - start) / 2, 10);
  if (array[pivot].GetObjectID() === objID) return pivot;
  if (end - start <= 1) return array[pivot].GetObjectID() > objID ? pivot - 1 : pivot;
  if (array[pivot].GetObjectID() < objID) {
    return locationObj(objID, array, pivot, end);
  } else {
    return locationObj(objID, array, start, pivot);
  }
}
